/* Cookie consent (Shopify's banner). While it is open, its height is --ll-consent-offset on <html> and
   html.ll-consent-open is set, so drawers, the booking panel and the booking bar end above it instead of
   hiding their buttons behind it (laserlab-consent.css). Nothing about the banner itself changes. */
(() => {
  if (window.LaserlabConsentOffset) return;
  window.LaserlabConsentOffset = true;
  const root = document.documentElement;
  let banner = null;
  let last = -1;
  const sync = () => {
    const shown = !!banner && banner.isConnected && banner.getClientRects().length > 0 && getComputedStyle(banner).visibility !== 'hidden';
    const height = shown ? Math.ceil(banner.getBoundingClientRect().height) : 0;
    if (height === last) return;
    last = height;
    root.style.setProperty('--ll-consent-offset', `${height}px`);
    root.classList.toggle('ll-consent-open', height > 0);
  };
  const resize = 'ResizeObserver' in window ? new ResizeObserver(sync) : null;
  const find = () => {
    const node = document.getElementById('shopify-pc__banner');
    if (node && node !== banner) {
      if (banner && resize) resize.unobserve(banner);
      banner = node;
      if (resize) resize.observe(node);
      new MutationObserver(sync).observe(node, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
    }
    sync();
  };
  const start = () => {
    new MutationObserver(find).observe(document.body, { childList: true });
    window.addEventListener('resize', sync, { passive: true });
    find();
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
